import { call, put, delay } from "redux-saga/effects";
import { sampleApi, subscriptionAPI } from "@services/api";
import { isSubscribedActions } from "../slices";

function* isSubscribedWorker({ payload }) {
  // yield delay(300);
  try {
    yield put(isSubscribedActions.reset());
    yield put(isSubscribedActions.pending());
    const response = yield call(subscriptionAPI.isSubscribed, payload);
    yield put(isSubscribedActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(isSubscribedActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { isSubscribedWorker };
